import { ref } from "vue";

//Arquivo da notificaçao GlobalNotifications

const notifications = ref([]);

function notify(message, color = "success", options = {}) {
    notifications.value.push({
        message,
        color,
        confirmText: options.confirmText,
        cancelText: options.cancelText,
    });
}


// função para remover a notificação
function removeNotification() {
    if (notifications.value.length > 0) {
        notifications.value.shift();
    }
}


// função que qualquer componente pode chamar
export function useNotify() {
    return { notifications, notify, removeNotification };
}

// exportamos a função notify para ser usada diretamente no main.js
export { notify };
